import { createFileRoute } from "@tanstack/react-router";
import type React from "react";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { apiClient } from "../../../zodios/client";
import HubspotTable from "../../../modules/hubspot/HubspotTable";
import Loading from "../../../components/core/blocks/Loading";
import { PageContainer } from "../../../components/core/basic/PageContainer";
import Card from "../../../components/core/basic/Card";
import type { HubspotTicket } from "../../../zodios/apiDefinitions/api/tickets";

const FetchTickets: React.FC = () => {
  const { t } = useTranslation(["hubspot"]);
  const {
    isPending,
    error,
    data: allTickets,
  } = useQuery<HubspotTicket[]>({
    queryKey: ["hubspotTickets"],
    queryFn: async () => await apiClient.getTickets(),
  });

  if (isPending) {
    return <Loading fullPage={false} height={300} />;
  }

  if (error) {
    return <div>{t(($) => $.hubspot["Error fetching tickets: {message}"], { message: error.message })}</div>;
  }
  return (
    <PageContainer>
      <Card>
        <h3>{t(($) => $.hubspot["Hubspot Tickets"])}</h3>
        <HubspotTable tickets={allTickets} />
      </Card>
    </PageContainer>
  );
};

export const Route = createFileRoute("/_authenticated/user/tickets")({
  component: FetchTickets,
  staticData: { application: "Admin" },
});
